import { useEffect, useState, useMemo } from "react"
import { useLocation } from 'react-router-dom'
import { Button, Table, Space, Modal, Form, Select, DatePicker, message, InputNumber } from 'antd'
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from "../../js/permission"
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import _ from 'lodash'
import moment from "moment"

const { Column } = Table
const { Option } = Select

export default function() {
    const location = useLocation()
    // 页面传递参数
    const [storeRow, setStoreRow] = useState<any>({
        })
    const permission: string[] = useMemo(() => getPermission(), [window.location.pathname])
    // 获取价格管理列表
    const [loading, setLoading] = useState(false)
    const [foodPriceList, setFoodPriceList] = useState([])
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 8,
        total: 0
    })
    const [editVisible, setEditVisible] = useState<boolean>(false)
    // 添加编辑食材价格-提交
    const [foodInfo, setFoodInfo] = useState({
        isAdd: true, // 区分是增加还是编辑
        price_detail_id:'', // 价格详情id
        food_type_id: undefined, // 食材分类类型 id
        food_item_id: undefined, // 当前编辑的食材 id
        food_item_name: '', // 食材名称
        buy_unit: '', // 食材单位
        effective_date: undefined, // 生效日期
        food_price: '', // 价格
        status: 0// 食材价格生效状态
    })

    // 食材列表
    const [foodTypeList, setFoodTypeList] = useState([])
    // 食材菜品列表
    const [footItemList, setFoodItemList] = useState([])

    // 获取对应门店食材价格列表
    const fetch = () => {
        const { state } = location as any
        if(state) {
            setLoading(true)
            setStoreRow(state)

            const iPagination: any = { ...pagination }
            iPagination.size = iPagination.pageSize
            iPagination.page = iPagination.current
            delete iPagination.pageSize
            delete iPagination.total
            delete iPagination.current

            axiosTable.get('/cooking/price/detail', {
                params: {
                    ...iPagination,
                    price_id: state.price_id,
                }
            }).then((response: any) => {
                setLoading(false)
                let p: any = { ...pagination }
                p.total = response.total
                setPagination(p)
                setFoodPriceList(response.records)
            }).catch(() => {
                setLoading(false)
            })
        } else {
            setStoreRow({})
        }
    } 

    useEffect(() => {
        fetch()
    }, [])

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        setPagination(p)
    }

    // 获取菜品类型列表
    const fetchFoodTypeList = () => {
        baseAxiosNoInfo('/cooking/global/food_type_list')
            .then((res:any)=>{
                setFoodTypeList(res)
            })
    }
    // 根据菜品类型获取菜品列表
    const fetchFoodItemList = (food_type_id: any) => {
        baseAxiosNoInfo('/cooking/global/food_item_list', {
            params: {
                food_type_id
            }
        }).then((res: any) => {
            if (res && res.length) {
                setFoodItemList(res)
            } else {
                setFoodItemList([])
            }
        })
    } 

    const handleInputChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(foodInfo)
        params[attr] = value
        setFoodInfo(params)
    }

    // 食材价格提交
    const onFinish = () => {
        let saveData: any = _.cloneDeep({
            ...foodInfo,
            ...storeRow
        })
        if(!saveData.food_item_id) {
            return message.error('请添加食材名称信息')
        } 
        else if(!saveData.effective_date) {
            return message.error('请选择生效日期')
        }
        else if(!saveData.food_price) {
            return message.error('请添加食材价格')
        }
        saveData.effective_date = moment(saveData.effective_date).format('YYYY-MM-DD') as any

        let apiUrl = saveData.isAdd ? '/cooking/price/add' : '/cooking/price/update'
        if(saveData.isAdd) {
            delete saveData.price_detail_id
            delete saveData.isAdd
            delete saveData.store_name
            delete saveData.update_time
            delete saveData.update_user_name
            delete saveData.buy_unit
            delete saveData.status
            delete saveData.food_type_id
            delete saveData.food_item_name
        } else {
            delete saveData.isAdd
            delete saveData.store_name
            delete saveData.update_time
            delete saveData.update_user_name
            delete saveData.buy_unit
            delete saveData.status
            delete saveData.food_type_id
            delete saveData.food_item_id
            delete saveData.food_item_name
            delete saveData.price_id
        }

        baseAxiosComplete.post(apiUrl, {
            ...saveData
        }).then((res:any) => {
            if(res.status == 0) {
                fetch()
                setEditVisible(false)
            }
        })
    }

    // 金额输入框小数点控制后两位
    const limitDecimals = (value:any) => {
        const reg = /^(\-)*(\d+)\.(\d\d).*$/;
        const data = value.replace(/[^0-9.]/g, "")//取数字
        return data.replace(reg, '$1$2.$3')// 取小数点后两位
    }

    return (
        <div className="common-page">
            <BreadCrumb position={['膳食中心', '设置价格']} />
            <div className="common-top-form">
                <div>
                    <Space style={{marginRight: '20px'}}>当前门店: {storeRow.store_name}</Space>
                    <Space style={{marginRight: '10px'}}>
                        <Button type="primary" onClick={() => {
                            fetchFoodTypeList()
                            setFoodInfo({
                                isAdd: true,
                                price_detail_id:'',
                                food_type_id: undefined,
                                food_item_id: undefined,
                                food_item_name: '',
                                buy_unit: '',
                                effective_date: undefined,
                                food_price: '',
                                status: 0
                            })
                            setEditVisible(true)
                        }}>添加食材价格</Button>
                    </Space>
                    <Space>
                        <Button type="default" onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </div>
            </div>
            <div className="common-main">
                <Table
                    loading={loading}
                    dataSource={foodPriceList} 
                    bordered={true} 
                    rowKey="price_detail_id"
                    pagination={pagination} 
                    onChange={handleTableChange}
                >
                    <Column title="食材" dataIndex="food_item_name" key="food_item_name" />
                    <Column title="价格(元/单位)" dataIndex="food_price" key="food_price" render={(text, record: any) => {
                        const { food_price, buy_unit } = record
                        return `${food_price}元/${buy_unit}`
                    }}/>
                    <Column title="生效日期" dataIndex="effective_date" key="effective_date" />
                    <Column title="状态" dataIndex="status" key="status" render={(text, record: any) => {
                        const { status } = record
                        if(status == 0) {
                            return '待生效'
                        } else if(status == 1) {
                            return '生效中'
                        } else {
                            return '已失效'
                        }
                    }}/>
                    <Column
                        title="操作"
                        key="action"
                        render={(text, record: any) => (
                            <Space size="middle">
                                {/* {permission.includes('编辑') && (
                                    <Button type="primary" 
                                        onClick={()=>{}}>
                                        编辑
                                    </Button>
                                )} */}
                                <Button type="primary" 
                                    onClick={()=>{
                                        record.effective_date = moment(record.effective_date)
                                        fetchFoodTypeList()
                                        fetchFoodItemList(record.food_type_id)
                                        setFoodInfo({
                                            isAdd: false,
                                            price_detail_id:'',
                                            food_type_id: undefined,
                                            food_item_id: undefined,
                                            food_item_name: '',
                                            buy_unit: '',
                                            effective_date: undefined,
                                            food_price: '',
                                            status: 0,
                                            ...record
                                        })
                                        setEditVisible(true)
                                    }}>
                                    编辑
                                </Button>
                            </Space>
                        )}
                    />
                </Table>
            </div>
            {/* 食材价格编辑弹窗 */}
            <Modal
                width={480}
                title={(foodInfo.price_detail_id ? '编辑':'添加') + '食材价格'}
                visible={editVisible}
                footer={false}
                maskClosable={false}
                onCancel={()=>{setEditVisible(false)}}>
                <Form>
                    <Form.Item label="食材名称">
                        <Select
                            virtual={false}
                            placeholder="食材分类"
                            value={foodInfo.food_type_id}
                            onChange={(val) => {
                                handleInputChange(val, 'food_type_id')
                                fetchFoodItemList(val)
                            }}
                            style={{ width: 160,marginRight:12,marginBottom:12 }} 
                        >
                            {
                                foodTypeList.map((el:any)=>(
                                    <Option value={el.food_type_id} 
                                        key={el.food_type_id}>
                                        {el.food_type_name}
                                    </Option>
                                )) 
                            }   
                        </Select>
                        <Select
                            virtual={false}
                            placeholder="食材名称"
                            value={foodInfo.food_item_id}
                            onChange={(val) => {
                                handleInputChange(val, 'food_item_id')
                            }}
                            style={{ width: 160,marginRight:12,marginBottom:12 }} 
                        >
                            {
                                footItemList.map((el:any)=>(
                                    <Option value={el.food_item_id} 
                                        key={el.food_item_id}>
                                        {el.food_item_name}
                                    </Option>
                                )) 
                            }   
                        </Select>
                    </Form.Item>
                    <Form.Item label="生效日期">
                        <DatePicker
                            style={{ width: 330,marginRight:12,marginBottom:12 }} 
                            value={foodInfo.effective_date}
                            onChange={(val) => {
                                handleInputChange(val, 'effective_date')
                            }} 
                        />
                    </Form.Item>
                    <Form.Item label="食材价格">
                        <InputNumber
                            style={{ width: 330,marginRight:12,marginBottom:12 }} 
                            placeholder="食材价格"
                            formatter={limitDecimals}
                            value={foodInfo.food_price}
                            onChange={(val) => {
                                handleInputChange(val, 'food_price')
                            }}
                        />
                    </Form.Item>
                    <Form.Item style={{textAlign: 'center'}}>
                        <Button style={{margin: '0 10px', width: '120px'}} type="default" onClick={() => {setEditVisible(false)}}>取消</Button>
                        <Button style={{margin: '0 10px', width: '120px'}} type="primary" onClick={() => { onFinish() }}>提交</Button>
                    </Form.Item>
                </Form> 
            </Modal>                            
        </div>
    )
}